export const OHL = {
    name: 'DV 1230 RP ĐERDAP 2 - HE ĐERDAP 2, blok 5',
    voltage: '110',
    regionCode: 'BR',
    stanice: [{name: 'ĐERDAP 2', position: {lat: 44.2983, lng: 22.565}}],
    stubovi: [
        { index: 1, name: 'P', lat: 44.2982 , lng: 22.5642, sys: 1, portal: true },
        { index: 2, name: '22', lat: 44.2983 , lng: 22.5629, sys: 1},
        { index: 3, name: '21', lat: 44.2988 , lng: 22.5611, sys: 1},
        { index: 4, name: '20', lat: 44.2998 , lng: 22.5604, sys: 1},
        { index: 5, name: '19', lat: 44.3018 , lng: 22.5624, sys: 1},
        { index: 6, name: 'P.B.-5', lat: 44.3019 , lng: 22.5626, sys: 1, portal: true }
    ],
    rasponi: [
        { name: 'P - 22', position: [{ lat: 44.2982 , lng: 22.5642 }, { lat: 44.2983 , lng: 22.5629 }] },
        { name: '22 - 21', position: [{ lat: 44.2983 , lng: 22.5629 }, { lat: 44.2988 , lng: 22.5611 }] },
        { name: '21 - 20', position: [{ lat: 44.2988 , lng: 22.5611 }, { lat: 44.2998 , lng: 22.5604 }] },
        { name: '20 - 19', position: [{ lat: 44.2998 , lng: 22.5604 }, { lat: 44.3018 , lng: 22.5624 }] },
        { name: '19 - P.B.-5', position: [{ lat: 44.3018 , lng: 22.5624 }, { lat: 44.3019 , lng: 22.5626 }] }
    ]
}
